import { CONST } from "../sideTypes"
import { MenuItemCategory, MenuItemType, ScreenActions } from "../../Components/navigationTypes"

export const documentsList: Array<MenuItemType> = [
    {
        label: "Documents",
        navigate: {
            component: "main",
            url: "lfmaster.asp",
        },
        subItems: [
            {
                label: "From Vendor",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    reactFrame: 'builderdoc',
                    controller: {
                        tabName: "Documents",
                    }
                },
                addOptions: [],
                type: MenuItemCategory.Default,
            }
        ],
        addOptions: [],
        type: MenuItemCategory.Heading,
        requiredFields: [{ field: "getVIPInfoMsgID" }]
    },
    {
        label: "Document",
        navigate: {
            component: "main",
            url: "lfmaster.asp",
        },
        subItems: [
            {
                label: "External Cloud Storage",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Documents",
                        screenAction: ScreenActions.openCloudDrive,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.WindowOpen,
                requiredFields: [{ field: "getLawyerSaveMergeDocMode", value: "SaveToUserCloud" }],
            }
        ],
        addOptions: [],
        type: MenuItemCategory.Heading,
        requiredFields: [{ field: "getLawyerSaveMergeDocMode", value: "SaveToUserCloud" }],
    },
    {
        label: "Document Generation",
        navigate: {
            component: "main",
            url: "lfmaster.asp",
        },
        subItems: [
            {
                label: "All",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Documents",
                        autoClick: "documentListGroupingMethod2",
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "Category",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Documents",
                        autoClick: "documentListGroupingMethod",
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "Package",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                        "PSM": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Documents",
                        autoClick: "documentListGroupingMethod1",
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "",
                navigate: undefined,
                addOptions: [],
                type: MenuItemCategory.Alert,
                jsxParams: {
                    variant: "primary",
                    jsx: [
                        {
                            tag: 'span',
                            text: 'To generate multiple documents as a '
                        },
                        {
                            tag: 'b',
                            text: 'custom package'
                        },
                        {
                            tag: 'span',
                            text: ', hold CTRL + click on the document names'
                        }
                    ]
                }
            }
        ],
        addOptions: [],
        type: MenuItemCategory.Heading,
    },
    {
        label: "Forms & Stationery",
        navigate: {
            component: "main",
            url: "lfmaster.asp",
        },
        subItems: [
            {
                label: "Letter, Envelope & Fax",
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Documents",
                        autoClick: "labelEnvFaxButton",
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "Registration Documents",
                appCode: ["RPW"],
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Documents",
                        autoClick: "RegistrationDocuments",
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            {
                label: "OREA Forms",
                appCode: ["RPW"],
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Documents",
                        autoClick: "OREAFormsButton",
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default,
                requiredFields: [{ field: "getUserID" }],
                requiredSessionFields: [
                    { field: "IsCollege", value: false}
                ],
            },
            {
                label: "OREA Forms",
                appCode: ["RPW"],
                navigate: {
                    component: "main",
                    controller: {
                        tabName: "Documents",
                        screenAction: ScreenActions.openModalDialogue,
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default,
                requiredSessionFields: [
                    { field: "IsCollege", value: true}
                ],
            },
            {
                label: "Ontario Forms",
                appCode: ["RPW"],
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Documents",
                        autoClick: "OntarioFormsButton",
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
            // {
            //     label: "EFS",
            //     appCode: ["RPWBC"],
            //     navigate: {
            //         component: "main",
            //         url: "lfmaster.asp",
            //         params: {
            //             "tb": "TPAppXML",
            //             "formasp": "purfileedit",
            //             "id": CONST.uninitialized,
            //         },
            //         controller: {
            //             tabName: "Documents",
            //             autoClick: "EFSButton",
            //         },
            //     },
            //     addOptions: [],
            //     type: MenuItemCategory.Default
            // },
            {
                label: "Enclosures",
                appCode: ["RPWSK", "RPWMB"],
                navigate: {
                    component: "main",
                    url: "lfmaster.asp",
                    params: {
                        "tb": "TPAppXML",
                        "formasp": "purfileedit",
                        "id": CONST.uninitialized,
                    },
                    controller: {
                        tabName: "Documents",
                        autoClick: "EnclosuresButton",
                    },
                },
                addOptions: [],
                type: MenuItemCategory.Default
            },
        ],
        addOptions: [],
        type: MenuItemCategory.Heading
    },
]